"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Routes = _interopRequireDefault(require("./Routes"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _epics = _interopRequireDefault(require("./epics"));

var _constants = require("./constants");

var _Scopes = _interopRequireDefault(require("./constants/Scopes"));

var _scopeChecks = require("settings-ui-lib/utils/scopeChecks");

var _default = {
  reducer: _reducers.default,
  routes: _Routes.default,
  route: _constants.ROUTE,
  rootEpic: _epics.default,
  shouldModuleRender: (0, _scopeChecks.matchesSomeScopes)(_Scopes.default)
};
exports.default = _default;
module.exports = exports.default;